import { getUsername } from '@saviynt/common';
import { Cookies } from 'react-cookie';

/**
 * Gets a cookie value with fallback support for local development
 * @param cookieName - Name of the cookie to retrieve
 * @param fallbackValue - Optional fallback value for local development
 * @returns Cookie value, fallback value, or undefined if not found
 */
export const getCookieValue = (
  cookieName: string,
  fallbackValue?: string
): string | undefined => {
  const cookies = new Cookies();
  const value = cookies.get(cookieName) as string | undefined;

  if (value) {
    return value;
  }

  // Only use fallback in rules app standalone local development (yarn dev)
  if (process.env.REACT_APP_RULES_LOCAL_DEV === 'true' && fallbackValue) {
    return fallbackValue;
  }

  return undefined;
};

/**
 * Gets the current user's key from cookies
 * @returns User key string or undefined if not found
 */
export const getUserKey = (): string | undefined =>
  getCookieValue('userKey', '12345');

/**
 * Gets the current user's name from the Redux store via @saviynt/common.
 * Supports HttpOnly migration of user_name cookie (UI-1467).
 * @returns User name string or undefined if not found
 */
export const getUserName = (): string | undefined => {
  const username = getUsername();

  if (username) {
    return username;
  }

  // Fallback for standalone local development only
  if (process.env.REACT_APP_RULES_LOCAL_DEV === 'true') {
    return 'Dev User';
  }

  return undefined;
};
